import React, {forwardRef} from 'react'
import _ from 'lodash'

// custom components
import Item from './Item'

const ItemList = forwardRef(({items}, ref) => {
  return (
    <div ref={ref} className="c-gantt__item-list">
      {_.map(items, (r, i) => (r.groupOnly ? <div key={i}></div> : <Item key={i} data={r} />))}
    </div>
  )
})

export default ItemList
